const CONFIG = require("./config.json");

export default CONFIG;
